import React, { useEffect, useRef, useState } from "react";
import DynamicSearchBar from "@components/common/SearchBar";
import Button from '@components/common/Button';
import PlusSvgIcon from '@assets/svg_main/plus.svg';
import OverlayCard from "@components/common/OverlayCard";
import SettingIcon from '@assets/svg_main/settings.svg';
import CrossIcon from '@assets/svg_main/CrossIconBlack.svg';
import OverlayComponent from "@pages/UserManagement/OverlayComponent";
import ActionComponent from "../Geo/ActionComponenet/index";
import _ from "lodash";
import axios from "../../../utils/axiosExt";
import SearchableDropdownComponent from "@components/common/SearchableDropDown";
import DataTable from "@components/common/CommonDataTable";
import PageModelGeoNonGeo from "@components/common/PageModelGeoNonGeo";
import { COLUMN_HEADER_HEALTH_DIVISION } from "@pages/GeoNonGeo/staticData";
import endpoints from "@config/endpoints";
import CreateNewNonGeo from "./create";
import IGridView from "../components/ZoneGridView/IGridView";
import { useNavigate } from "react-router-dom";
import DownloadModal from "@components/common/DownloadModal";
import DownArrow from '@assets/svg/download-01.svg';
import { PagePermission } from './../../../services/usePermission';
import Auth from '../../../utils/auth';
import { WithPermission } from "@components/Auth/withPermission";
import { errorLogger } from "@utils/applicationLogUtils";

import isUsingGramPanchayatUtils from "@utils/isUsingGrampanchayatUtil";
const columnHeader=[ {
    name: 'Name',
    key: 'name',
    showDetails: 'health_name_block',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
},
{
    name: 'Type',
    key: 'type_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180
},
{
    name: 'Mapped Village Count',
    key: 'mapped_village_count',
    showDetails: 'mapped_village_count',
    sortable: false,
    filterRequired: false,
    filterDefault: true,
    width: 180,
},
{
    name: 'Mapped Wards Count',
    key: 'mapped_wards_count',
    showDetails: 'mapped_wards_count',
    sortable: false,
    filterRequired: false,
    filterDefault: true,
    width: 180,
},
{
    name: 'Action',
    key: 'Action',
    sortable: false,
    filterRequired: false,
    filterDefault: false,
    width: 180,
}];
const columnHeaderGrampanchayat=[ {
    name: 'Name',
    key: 'name',
    showDetails: 'health_name_block',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
},
{
    name: 'Type',
    key: 'type_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180
},
{
    name: 'Mapped Gram Panchayat / ADC Village Count',
    key: 'mapped_gram_panchayat_count',
    showDetails: 'mapped_gram_panchayat_count',
    sortable: false,
    filterRequired: false,
    filterDefault: true,
    width: 180,
},
{
    name: 'Mapped Wards Count',
    key: 'mapped_wards_count',
    showDetails: 'mapped_wards_count',
    sortable: false,
    filterRequired: false,
    filterDefault: true,
    width: 180,
},
{
    name: 'Action',
    key: 'Action',
    sortable: false,
    filterRequired: false,
    filterDefault: false,
    width: 180,
}];

const constructActionData = (dataList: any) => {
    return dataList.map((data: any) => {
        return {
            ...data,
            Action: {
                type: 'component',
                component: ActionComponent,
            },
        };
    }).reverse();
};

interface objectType {
    [key: string]: any;
}
let data: any[] = [];
const style = {
    singleValue: (baseStyles: any) => ({
        ...baseStyles,
        fontSize: '12px',
        color: '#797979',
        textAlign: 'center',
        padding: '5px 10px',
    }),
    option: (baseStyles: any, state: any) => ({
        ...baseStyles,
        fontSize: '12px',
        color: state.isFocussed ? '#FFF' : '#797979',
        '&:hover': {
            color: '#FFF',
        },
    }),
    menu: (style: any) => ({
        ...style,
        maxHeight: 250,
    }),
    menuList: (style: any) => ({
        ...style,
        maxHeight: 250,
        overFlowY: 'auto',
    }),
    placeholder: (base: any, state: any) => ({
        ...base,
        marginTop: 5,
        marginLeft: 5,
        color: 'rgba(179, 179, 179, 1)',
        fontWeight: 400,
        fontSize: 12,
        display: state.isFocused && 'none',
    }),
    multiValue: (base: any, state: any) => ({
        ...base,
        minWidth: '55px',
    }),
    valueContainer: () => ({
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'overlay',
        marginLeft: 5,
        fontSize: 12,
    }),
};




const HealthBlockGridView = ({ searchBar, button, grid,modal:Modal,errors,handleSave,finishHandler,fetchData}: IGridView) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [prevSearchTerm, setPrevSearchTerm] = useState<string>('');
    const [modal, setModal] = useState<boolean>(false);
    const [checkboxValue, setCheckboxValue] = useState<any>({});
    const [gridData, setGridData] = useState<any[]>([]);
    const [eventKeyval, seteventKeyval] = useState<any[]>([]);
    const [show, setShow] = useState<boolean>(false);
    const [dataExport, setDataExport] = useState<any[]>([]);
    const [dropDownFilterList, setDropDownFilterList] = useState<any>({});
    const [closeDownloadModal,setCloseDownloadModal]=useState<boolean>(false);
    const [isGramPanchayat,setIsGrampanchayat]=useState<boolean>(false);
    const [filterCheckBoxKeys,setFilterCheckBoxKeys]=useState<any>({});
    let filterCheckBox: objectType = {};
    let dropdowndata: objectType = {};
    const canCreateUser = PagePermission("GeoNG_HBSD", "GeoNG_HBSD_CrPg");
    const checkGramPanchayat=async ()=>{
      const stateCode= localStorage.getItem('userStateCode');
      if(stateCode){
    
         setIsGrampanchayat(await isUsingGramPanchayatUtils(stateCode));
      }
      else{
        setIsGrampanchayat(false);
    }
    }
   
const dropDownKeys = _.filter(
    isGramPanchayat ?columnHeaderGrampanchayat:columnHeader,
    (filterList) => filterList.filterRequired,
);
    //setting initial checkbox value to true
    
    const formatData = (res: any,searchIsTyped:boolean=false) => {
        dropDownKeys.forEach((item, idx) => {
            const option = _.map(_.uniq(_.map(res.data.data, item.key)), (i) => {
                return { value: i, label: i };
            });
            dropdowndata = {
                ...dropdowndata,
                [item.key]: option,
            };
            filterCheckBox = {
                ...filterCheckBox,
                [item.key]: idx < 3,
            };
            setFilterCheckBoxKeys(filterCheckBox);
        });
        let modifiedData = constructActionData(res.data.data);
        data = modifiedData;
        if(searchIsTyped){
            modifiedData = transformDataArray(modifiedData)
        }
        const filterlistfromSession = sessionStorage.getItem('healthBlockFilter');
        const parseToObject = filterlistfromSession ? JSON.parse(filterlistfromSession) : null;
        parseToObject ? setCheckboxValue({ ...parseToObject }) : setCheckboxValue({ ...filterCheckBox });
        setGridData(modifiedData.reverse());
    }

    const transformDataArray=(dataArray:any)=> {
        return dataArray.map((item:any) => {
          const transformedItem:any = {};
          for (const key in item) {
            if (key.startsWith("hb_sd_")) {
              const newKey = key.replace("hb_sd_", "");
              const finalKey = newKey;
              transformedItem[finalKey] = item[key];
            }
             if (key === "village_count") {
                transformedItem["mapped_village_count"]=item[key];
              }
             if (key === "gp_count") {
                transformedItem["mapped_gram_panchayat_count"]=item[key];
              }
              if (key === "ward_count") {
                transformedItem["mapped_wards_count"]=item[key];
              }

          }
          return transformedItem;
        });
      }

      
    //   const enrichDataArrayWithWardsAndVillages=async(dataArray:any)=> {
    //     try {
    //       const updatedDataArray:any = [];
      
    //       for (const item of dataArray) {
    //         const healthBlockId = item.id;
    //         const villagesResponse=await axios.get(`${endpoints.getVillagesByHBSDId}/${healthBlockId}`);
    //         const wardsResponse=await axios.get(`${endpoints.getWardsByHBSDId}/${healthBlockId}`);
    //         const villagesData = villagesResponse.data.data.map((village: any) => village.village_name).join(",");
    //         const wardsData = wardsResponse.data.data.map((ward: any) => ward.ward_name).join(",");
    //         item.village = villagesData;
    //         item.villages = villagesResponse.data.data;
    //         item.ward = wardsData;
    //         item.wards = wardsResponse.data.data;
    //         updatedDataArray.push(item);
    //       }
      
    //       return updatedDataArray;
    //     } catch (error) {
    //       // Handle error (e.g., return original dataArray without districts)
    //       return dataArray;
    //     }
    //   }
      

    const initialFetch =async () => {
      try{
        const responseAPI:any = await axios.get(`${endpoints.getAllHealthBlockAndSubDiv}`, Auth.loggedIn())
        // const updatedKeys =await enrichDataArrayWithWardsAndVillages(transformDataArray(responseAPI.data.data));
        const updatedKeys =await transformDataArray(responseAPI.data.data);
        setDataExport(responseAPI?.data?.data); 
        
        const Response ={
            data:{
                data:updatedKeys
            }
        }
        formatData(Response);
      }  catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
      }
    }
    const mountedRef = useRef(false);
    useEffect(() => {
        if (!mountedRef.current) {
          mountedRef.current = true;
          return;
        }
        if (searchTerm.trim().length === 0) {
          initialFetch();
          return;
        }
        if(prevSearchTerm && prevSearchTerm === searchTerm.trim()){
            return;
        }
        setPrevSearchTerm(searchTerm.trim());
        searchTerm.trim().length >=3 && callSearchAPI(searchTerm.trim());
      }, [searchTerm]);

    const callSearchAPI = async (searchTerm: string) => {
        const responseAPI = await axios.get(endpoints.getHealthBlockAndSubDivBySearch(searchTerm), Auth.loggedIn());
        setDataExport(responseAPI?.data?.data); 
        // const updatedKeys =await enrichDataArrayWithWardsAndVillages(transformDataArray(responseAPI.data.data));
        const updatedKeys =await transformDataArray(responseAPI.data.data);
        
        const Response ={
            data:{
                data:updatedKeys
            }
        }
        formatData(Response,false);
    }

    useEffect(() => {
        checkGramPanchayat();
        initialFetch();
    }, []);

    useEffect(() => {
        const list = getDropDownOptions(gridData);
        setDropDownFilterList({ ...list});
      }, [gridData]);

    const filterLoop = (dataList: any[], key: string, keyFilter: string[]) => {
        const tempData: any[] = [];
        dataList.forEach((dataValue: any) => {
            if (keyFilter.find((val) => val === dataValue[key])) {
                tempData.push(dataValue);
            }
        });
        return tempData;
    };

    const applyFilter = (eventKey: any, index: number, eValue: any) => {
        const updatedValues = [...eventKeyval];
        updatedValues[index] = eventKey;
        seteventKeyval(updatedValues);
        let tempData: any = [...data];
        const keyNames = Object.keys(filterCheckBoxKeys);
        updatedValues.forEach((keyFilter: any, i: number) => {
            const key = keyNames[i];
            if (keyFilter && keyFilter.length >= 1) {
                tempData = filterLoop(tempData, key, keyFilter);
            }
        });
        setGridData(tempData);
    };

    const clearFilter = () => {
        seteventKeyval([]);
        setGridData(data);
    };

    const onChangeCheckbox = (list: any) => {
        setCheckboxValue({ ...list });
        sessionStorage.setItem("healthBlockFilter", JSON.stringify({ ...list }));
        setShow(false);
    };

    const getDropDownOptions = (data:any) => {
        let dropdowndataValue = {};
        dropDownKeys.forEach((item, idx) => {
          const itemMap = _.map(data, (itemKey) => {
            if(itemKey[item.key] && itemKey[item.key].type == 'component') {
              return itemKey[item.key].value
            } else {
              return itemKey[item.key] 
            }
          });
          const uniquList = _.uniq(itemMap);
      
          const option = _.map(uniquList, (i) => {
            if(i){
              if(i.type == 'component') {
                return { value: i.value, label: i.value };
              } else {
                return { value: i, label: i };
              }
            }
          });
          const options=option.filter((item:any)=>item!==undefined);
      
          dropdowndataValue = {
            ...dropdowndataValue,
            [item.key]: options,
          };
        });
        return dropdowndataValue;
      }

    const renderFilter = () =>{
        return dropDownKeys.map((dropdata, index) => {
            const selectedDropdownValue =
                eventKeyval[index] &&
                eventKeyval[index].map((key: string) => ({
                    value: key,
                    label: key,
                }));
            if (!checkboxValue[dropdata.key]) return;
            return (
                <>
                    <SearchableDropdownComponent
                        options={dropDownFilterList[dropdata.key]}
                        placeHolder={dropdata.name}
                        multipleSelection={true}
                        onChange={(value) => applyFilter(value, index, dropdata.key)}
                        dropDownType="entered"
                        dropLabelName={dropdata.name}
                        dropDownDisable={false}
                        ifRequired={false}
                        dropdownsearchable={true}
                        isClearable={false}
                        className={'user-filter-dropdown'}
                        style={style}
                        value={selectedDropdownValue ? selectedDropdownValue : null}
                    />
                </>
            );
        });
    }
    const handleSearchChange = (value: string) => {
      const alphanumericRegex = /^[a-zA-Z0-9 ]*$/;
      if(alphanumericRegex.test(value)){
        setSearchTerm(value);
      }
    };

    const navigate = useNavigate();
    const showModal = () => {
        if (fetchData) {
            fetchData();
        }
        navigate(`/healthblock/create`);
        // setModal(true);
    };
    const closeModal = () => {
        setModal(false);
        initialFetch();
    };
    const excelData = dataExport.map((item, index) => ({
      serialNo: index + 1,
      ...item
    }));
    const dataToExportExcel = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'Sl.No.', value: 'serialNo' },
            { label: 'Health Block/Sub Division Name', value: 'hb_sd_name' },
            { label: 'Health Block/Sub Division Type', value: 'hb_sd_type_name' },
            { label: isGramPanchayat?'Mapped Gram Panchayat / ADC Village Count':'Mapped Villages Count', value: isGramPanchayat?'gp_count':'village_count' },
            { label: 'Mapped Wards Count', value: 'ward_count' },
          ],
          content: excelData,
        },
      ];
     
      const dataToExportPDF = {
        content: [
          { text: 'Health Block/Sub Division Data', style: 'header' },
          {
            table: {
              headerRows: 1,
              widths: Array(5).fill('auto'), // Adjust widths to fit all columns
              body: [
                [
                  { text: 'Sl.No.', style: 'tableHeader' },
                  { text: 'Health Block/Sub Division Name', style: 'tableHeader' },
                  { text: 'Health Block/Sub Division Type', style: 'tableHeader' },
                  { text: isGramPanchayat?'Mapped Gram Panchayat / ADC Village Count':'Mapped Villages Count', style: 'tableHeader' },          
                  { text: 'Mapped Wards Count', style: 'tableHeader' },          
    
                ],
                ...dataExport.map((item,index) => [
                  index+1,
                  item.hb_sd_name,
                  item.hb_sd_type_name,
                  isGramPanchayat?item.gp_count:item.village_count,          
                  item.ward_count,          
                ]),
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'black',
          },
          tableBody: {
            fontSize: 8,
          },
        },
        defaultStyle: {
          fontSize: 8,
        },
    
      };
      const downloadClick=()=>{
        setCloseDownloadModal(true);
      }
      const onCloseDownloadModal=(value:boolean)=>{
        if(value){
          setCloseDownloadModal(false);
        }
        else{
          setCloseDownloadModal(false);
        }
      }
    return <div className="user-management-details">
        <div className="search-add-user">
            <DynamicSearchBar
                onChange={handleSearchChange}
                placeHolder={"Search by Name"}
                disabled={false}
                className="user-search"
                iconNeeded={true}
                value={searchTerm}
            />
            {canCreateUser && ( 
              <Button
                onClick={showModal}
                disabled={false}
                id="add-user"
                buttonName={'Create Health Block/Sub Division'}
                colorType={'primary'}
                icon={<PlusSvgIcon />}
                iconPosition={'left'}
              />
            )}
        </div>
        <div className="user-filter">
            <div className="user-filter-label-icon">
                <h6 className="user-filter-label">FILTERS</h6>
                <div className='download_symbol_css'>
                    <DownArrow className='down_arrow_cursor' onClick={downloadClick}/>
                    {closeDownloadModal && <DownloadModal closeModal={onCloseDownloadModal} showModal={closeDownloadModal} dataToExportExcel={dataToExportExcel}
                    dataToExportPDF={dataToExportPDF}
                    fileNameToExport={"healthBlockSubDivision"}/>}
                <OverlayCard
                    show={show}
                    setShow={setShow}
                    triggerComponent={show ? <CrossIcon className="user-cross-icon" /> : <SettingIcon className="user-setting-icon" />}
                    trigger="click"
                    overlayComponent={OverlayComponent(
                        dropDownKeys,
                        onChangeCheckbox,
                        checkboxValue,
                    )}
                    placement="bottom-end"
                />
                </div>
            </div>
            <div className="filter">
                {dropDownKeys && dropDownFilterList && renderFilter()}
                {/* {Object.values(checkboxValue).includes(true) && */}
                {eventKeyval?.some((filter) => filter?.length > 0) &&
                    (
                        <Button
                            onClick={clearFilter}
                            disabled={false}
                            id="user-filter-clear"
                            buttonName={'Clear Filter'}
                            colorType={'save'}
                            icon={''}
                            iconPosition={''}
                        />
                    )}
            </div>

        </div>
        <div className="user-table">
        <WithPermission moduleCode="GeoNG_HBSD" pageCode='GeoNG_HBSD_LstPg' privilege="view">
            <DataTable
                data={gridData}
                itemsPerPage={[10, 20, 30, 40, 50]}
                height={'300px'}
                searchTerm={searchTerm}
                columnHeader={isGramPanchayat ?columnHeaderGrampanchayat:columnHeader}
                gridFor={'user'}
            />
        </WithPermission>
        </div>
        {/* {modal && <CreateNewNonGeo show={modal} closeModal={closeModal} />} */}

    </div>;
}


export default HealthBlockGridView;